module.exports = __webpack_public_path__ + "static/SignageDark-2e9ab523c8a9c5e8513c7616e52b5eee.png";